import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import Loading from '../../Components/Loading/Loading';
import Categories from './Components/Categories';
import Featured from './Components/Featured';
import Live from './Components/Live';
import * as service from "./service";
import { checkOsVersion } from '../../utils/utils';
import useScrollPosition from '../../Components/ScrollPosition/useScrollPosition';
import TopTrendingEpisodes from '../../Components/TopTrending/TopTrendingEpisodes';
import { getRandomItem } from "../../utils/utils";
import RedeemBanner from './Components/HomeSlider/RedeemBanner';
import GaiaBanner from './Components/GaiaSlider/GaiaBanner';
import NewReleases from '../../Components/NewReleases/NewReleases';
import GaiaCategories from './Components/GaiaSlider/GaiaCategories';
import MoreTopics from './Components/GaiaSlider/MoreTopics';
import GaiaGenres from './Components/GaiaSlider/GaiaGenres';
import MubiBanner from './Components/HomeSlider/MubiBanner';
import NetflixBanner from './Components/HomeSlider/NetflixBanner';
import OttHeroSlider from './Components/HomeSlider/OttHeroSlider';
import HomeHeroSlider from './Components/HomeSlider/HomeHeroSlider';
import TvShowHeroSlider from './Components/HomeSlider/TvShowHeroSlider';
import LivePlayer from '../LivePlayer/LivePlayer';
import LiveChannels2 from '../LiveChannels/LiveChannels2';
import NewBlockBanner from './Components/HomeSlider/NewBlockBanner';
import YowBanner from './Components/HomeSlider/YowBanner';
const Homepage = () => {

  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const pubid = projectInfo?.projectConfig?.pubid || projectInfo?.pubid;
  const isFlsTv = pubid == 50183;
  const isYowTv = pubid == 50187;

  const accessToken = useSelector((state) => state?.accessToken?.value);
  const user = useSelector((state) => state?.user?.value);

  const [loading, setLoading] = useState(true)
  const [homeData, setHomeData] = useState([])
  const [homeDataSliceCount, setHomeDataSliceCount] = useState(8);

  const homePageContainerRef = useRef()
  const scrollPosition = useScrollPosition();
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken
  }
  const location = useLocation();
  const params = useParams();
  const key = location?.state?.key || params?.key;

  useEffect(() => {
    if (!loading && homeDataSliceCount < homeData?.length) {
      lazyLoad()
    }
  }, [loading, scrollPosition, homeData])

  useEffect(() => {
    window.scroll(0, 0)
    setLoading(true)
    fetchShowDetails();

  }, [user, key])
  const fetchShowDetails = async () => {
    try {
      const response = await service.getShowsByCategory(appInfo, key);
      if (response?.status === 200) {
        setHomeData(response?.data?.data)
        setLoading(false)
      }
    }
    catch {
      setLoading(true)
    }
  }

  const lazyLoad = () => {
    const containerHeight = homePageContainerRef?.current?.clientHeight;
    if (scrollPosition + 2500 >= containerHeight) {
      setHomeDataSliceCount(homeDataSliceCount + 5)
    }
  }

  // const categoryShowsData = homeData?.filter(item => item?.type === "CATEGORY_SHOWS")?.reverse();
  // const categoryNames = homeData?.filter(item => item?.banner);

  if (loading) {
    return (
      <Loading />
    )
  }

  const banner = projectInfo?.projectConfig?.config?.WEBSITE_BANNER;
  const firstItem = homeData[0]?.type;
  const hasMoreTopics = template === "TEMPLATE_1" && homeData?.some(item => item?.type === "MORE_TOPICS");

  return (
    <div
      className={(template === "TEMPLATE_10" || (template === "TEMPLATE_1" && banner === "BANNER_5")) ? 'homePage gaia' : 'homePage' + (hasMoreTopics ? ' hasMoreTopics' : '')}
      style={(firstItem !== "FEATURED" && firstItem !== "LIVE") ? { paddingTop: '100px' } : {}}
      ref={homePageContainerRef}>
      {
        homeData?.map((item, index) => {
          if (item?.type === "LIVE") {
            return <LiveChannels2 key={"livechannels-homepage"} hideEpg={pubid === 50162} channelId={item?.shows?.[0]?.channel_id} />
          } else if (item?.type === "FEATURED") {
            if (isYowTv) {
              return <YowBanner key={index} data={item} />;
            }
            {
              if (!banner) {
                if (pubid === 50167) {
                  return <NetflixBanner key={index} data={item} />
                }
                if (template === "TEMPLATE_9" || template === "TEMPLATE_12") {
                  return <RedeemBanner key={index} data={item} />
                }
                else if (template === "TEMPLATE_10") {
                  return <GaiaBanner key={index} data={item} />
                }
                else if (template === "TEMPLATE_11") {
                  return <NewBlockBanner key={index} data={item} />
                }
                else {
                  return <Featured key={index} data={item} />
                }
              } else {
                if (banner === "BANNER_1") {
                  return <Featured key={index} data={item} />
                } else if (banner === "BANNER_2") {
                  return <RedeemBanner key={index} data={item} />
                } else if (banner === "BANNER_3" || banner === "BANNER_4") {
                  return <GaiaBanner key={index} data={item} />
                } else if (banner === "BANNER_5") {
                  return <MubiBanner key={index} data={item} />
                } else if (banner === "BANNER_6") {
                  return <NetflixBanner key={index} data={item} />
                } else if (banner === "BANNER_7") {
                  return <OttHeroSlider key={index} data={item} />
                } else if (banner === "BANNER_8") {
                  return <HomeHeroSlider key={index} data={item} />
                } else if (banner === "BANNER_9") {
                  return <TvShowHeroSlider key={index} data={item} />
                }
              }
            }
          }

          if (template === "TEMPLATE_10" && item?.type === "NEW_RELEASES") {
            return <NewReleases data={item} />
          }
          else if (item?.type === "TOP_TRENDING") {
            if (isYowTv) {
              return (
                <GaiaCategories
                  key={index}
                  data={item}
                  index={index}
                  onRemoveItem={(categoryId, videoId) => {
                    setHomeData(prev =>
                      prev.map(cat => {
                        if (cat?.id !== categoryId && cat?.type !== "CONTINUE_WATCHING") {
                          return cat;
                        }
                        const updatedShows = cat?.shows?.filter(
                          show => show.video_id !== videoId
                        );
                        return { ...cat, shows: updatedShows };
                      })
                    );
                  }}
                />
              );
            }
            return <TopTrendingEpisodes data={item} type={item?.type} />
          }
          else if (item?.type === "GENRES") {
            return <GaiaGenres data={item} />
          }
          else if (item?.type === "MORE_TOPICS") {
            return <MoreTopics data={item} />
          }
          else if (item?.type !== "FEATURED" && item?.type !== "LIVE") {
            const overlapBanner = (pubid === 50167 && homeData?.[index - 1]?.type === 'FEATURED');
            if (template === "TEMPLATE_10" || isFlsTv || isYowTv) {
              if (item?.shows && item.shows.length > 0) {
                return (<GaiaCategories key={index} data={item}
                  onRemoveItem={(categoryId, videoId) => {
                    setHomeData(prev =>
                      prev.map(cat => {
                        if (cat?.id !== categoryId && cat?.type !== "CONTINUE_WATCHING") {
                          return cat;
                        }

                        const updatedShows = cat?.shows?.filter(
                          show => show.video_id !== videoId
                        );

                        return {
                          ...cat,
                          shows: updatedShows
                        };
                      })
                        .filter(cat => {
                          if (cat?.id === categoryId || cat?.type !== "CONTINUE_WATCHING") {
                            return cat?.shows?.length > 0;
                          }
                          return true;
                        })
                    );
                  }
                  }
                />
                );
              }
              return null;
            } else {
              if (item?.shows && item.shows.length > 0) {
                const firstCardRowIndex = homeData.findIndex(homeItem =>
                  homeItem?.type !== "FEATURED" &&
                  homeItem?.type !== "LIVE" &&
                  homeItem?.type !== "TOP_TRENDING" &&
                  homeItem?.type !== "GENRES" &&
                  homeItem?.type !== "MORE_TOPICS" &&
                  homeItem?.type !== "NEW_RELEASES" &&
                  homeItem?.shows?.length > 0
                );
                return (<Categories key={index} data={item} overlapBanner={overlapBanner}
                  isPriority={index === firstCardRowIndex}
                  onRemoveItem={(categoryId, videoId) => {
                    setHomeData(prev =>
                      prev.map(cat => {
                        if (cat?.id !== categoryId && cat?.type !== "CONTINUE_WATCHING") {
                          return cat;
                        }

                        const updatedShows = cat?.shows?.filter(
                          show => show.video_id !== videoId
                        );

                        return {
                          ...cat,
                          shows: updatedShows
                        };
                      })
                        .filter(cat => {
                          if (cat?.id === categoryId || cat?.type !== "CONTINUE_WATCHING") {
                            return cat?.shows?.length > 0;
                          }
                          return true;
                        })
                    );
                  }
                  }
                />
                );
              }
              return null;
            }
          }
        })
      }
    </div>
  )
}

export default Homepage
